// ANCHOR Styletron
import { StyleObject } from 'styletron-react';

// ANCHOR Theme
import { BlockOverrides } from 'baseui/block';
import { THEME } from '@lyon/utils/theme';

export const AVATAR_SIZE = '120px';

export const SKELETON: StyleObject = {
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  objectFit: 'cover',
  display: 'block',
  boxSizing: 'border-box',
  borderBottomLeftRadius: '50%',
  borderBottomRightRadius: '50%',
  borderTopLeftRadius: '50%',
  borderTopRightRadius: '50%',
  borderLeftStyle: 'none',
  borderRightStyle: 'none',
  borderTopStyle: 'none',
  borderBottomStyle: 'none',
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: '56px',
      paddingBottom: '56px',
      backgroundColor: THEME.colors.darkmuted600,
      marginLeft: '4vw',
      marginRight: '4vw',
      minHeight: 0,
      marginBottom: '32px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',

      [THEME.media.large]: {
        marginLeft: 0,
        marginRight: 0,
        minHeight: '64vh',
        marginBottom: 0,
      },
    },
  },
};

export const HEADER: BlockOverrides = {
  Block: {
    style: {
      fontSize: '22px',
      fontWeight: 500,
      textAlign: 'center',
      marginTop: '24px',
      lineHeight: 1.25,
    },
  },
};

export const NORMAL_BASE: StyleObject = {
  fontSize: '14px',
  fontWeight: 400,
  color: THEME.colors.mono600,
  textAlign: 'center',
  textDecoration: 'none',
  overflowWrap: 'break-word',
  width: '240px',

  [THEME.media.large]: {
    marginRight: '12px',
    marginBottom: 0,
    textAlign: 'left',
  },
};

export const NORMAL: BlockOverrides = {
  Block: {
    style: NORMAL_BASE,
  },
};

export const ICON: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      marginRight: 0,
      marginTop: '8px',
      marginBottom: '8px',
      color: THEME.colors.mono600,

      [THEME.media.large]: {
        marginRight: '12px',
        marginBottom: 0,
        marginTop: 0,
      },
    },
  },
};

export const CENTER: BlockOverrides = {
  Block: {
    style: {
      fontSize: '14px',
      fontWeight: 400,
      color: THEME.colors.mono600,
      textAlign: 'center',
    },
  },
};

export const MEDIUM: BlockOverrides = {
  Block: {
    style: {
      fontSize: '14px',
      fontWeight: 500,
    },
  },
};
